import React, { useRef } from 'react';

import InputLabel from 'uiToolkitV1/InputLabel';
import MaterialUIAutoResizeTextArea from 'uiToolkitV1/MaterialUIAutoResizeTextArea';

export const QueryStringComp = ({ queryString, isDisabled, onChange, isReadOnly }) => {
  const inputRef = useRef();
  const onKeyDown = (ev) => {
    if (ev.key === 'Enter') {
      inputRef?.current?.blur();
    }
  };

  return (
    <InputLabel labelText="Query String">
      <MaterialUIAutoResizeTextArea
        placeholder="Enter custom query"
        ref={inputRef}
        isDashed
        value={queryString}
        onChange={onChange}
        onKeyDown={onKeyDown}
        isReadOnly={isReadOnly}
        isDisabled={isDisabled}
      />
    </InputLabel>
  );
};

export const CustomNumeratorComp = ({ queryString, isDisabled, onChange, isReadOnly }) => {
  const inputRef = useRef();
  const onKeyDown = (ev) => {
    if (ev.key === 'Enter') {
      inputRef?.current?.blur();
    }
  };

  return (
    <InputLabel labelText="Custom Numerator Query">
      <MaterialUIAutoResizeTextArea
        placeholder="Enter Numerator query"
        ref={inputRef}
        isDashed
        value={queryString}
        onChange={onChange}
        onKeyDown={onKeyDown}
        isReadOnly={isReadOnly}
        isDisabled={isDisabled}
      />
    </InputLabel>
  );
};

export const CustomDenominatorComp = ({ queryString, isDisabled, onChange, isReadOnly }) => {
  const inputRef = useRef();
  const onKeyDown = (ev) => {
    if (ev.key === 'Enter') {
      inputRef?.current?.blur();
    }
  };

  return (
    <InputLabel labelText="Custom Denominator Query">
      <MaterialUIAutoResizeTextArea
        placeholder="Enter Denominator query"
        ref={inputRef}
        isDashed
        value={queryString}
        onChange={onChange}
        onKeyDown={onKeyDown}
        isReadOnly={isReadOnly}
        isDisabled={isDisabled}
      />
    </InputLabel>
  );
};

export const QueryDetails = ({ queryMetric, isDisabled, isReadOnly }) => {
  const { isCustomQuery, query, ratioQuery, queryType, selectedMetricId } = queryMetric;

  if (isCustomQuery && ratioQuery) {
    return (
      <>
        <CustomNumeratorComp queryString={query} isDisabled={isDisabled} isReadOnly={isReadOnly} />
        <CustomDenominatorComp queryString={ratioQuery} isDisabled={isDisabled} isReadOnly={isReadOnly} />
        <QueryStringComp queryString={`${query}/${ratioQuery}`} isDisabled={isDisabled} isReadOnly={isReadOnly} />
      </>
    );
  }

  return <QueryStringComp queryString={query} isDisabled={isDisabled} isReadOnly={isReadOnly} />;
};
